import { useEffect, useState } from "react";
import { Card } from "../../../components/card/card";
import { dataTel3GetList, whatsappGetOutgoing } from "../../../config/apiSPA";
import Pagination3 from "../../../components/pagination/pagination3";
import Pagination1 from "../../../components/pagination/pagination1";
import DateTimeFormat from "../../../components/dateFormater/dateFormat2";
const mainDataPreset = {
  data: [],
  meta: null,
};
function WhatsappOutgoing() {
  const [mainData, setMainData] = useState(mainDataPreset);
  const [search1Value, setSearch1Value] = useState("");
  const handleNextClick = () => {
    loadData(search1Value, mainData.meta.current_page + 1);
  };
  const handlePrevClick = () => {
    loadData(search1Value, mainData.meta.current_page - 1);
  };
  const handleSubmitSearch = (e) => {
    e.preventDefault();
    console.log(search1Value);
    loadData(search1Value, "");
  };
  const loadData = async (search = "", page = "") => {
    const resList = await whatsappGetOutgoing(search, page);
    setMainData(resList);
  };
  useEffect(() => {
    loadData();
  }, []);
  return (
    <>
      <div>
        <div className="d-flex align-items-center mb-3">
          <div>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#/">Messaging</a>
              </li>
              <li className="breadcrumb-item active">Outgoing</li>
            </ul>

            <h1 className="page-header">
              Outgoing message <small></small>
            </h1>
          </div>
        </div>

        <hr className="mb-1" />
        <div className="my-3">
          <p className="card-text">
            Fitur ini digunakan untuk mengirim pesan secara otomatis melalui WhatsApp. Setiap pesan yang masuk ke dalam daftar <strong>Outgoing Message</strong> akan diproses dan dikirim secara bertahap untuk menjaga stabilitas pengiriman.
          </p>

          <p className="card-text">
            Pesan akan dikirim dengan jeda <strong>1 menit</strong> antar setiap pesan.
          </p>

          <h6>Status Pengiriman:</h6>
          <ul className="list-group list-group-flush mt-2">
            <li className="list-group-item">
              <span className="badge bg-secondary me-2">Pending</span>
              Pesan sedang dalam antrian dan menunggu untuk dikirim
            </li>
            <li className="list-group-item">
              <span className="badge bg-success me-2">Sent</span>
              Pesan berhasil dikirim
            </li>
            <li className="list-group-item">
              <span className="badge bg-danger me-2">Failed</span>
              Pengiriman pesan gagal
            </li>
            <li className="list-group-item">
              <span className="badge bg-warning text-dark me-2">Invalid Number</span>
              Nomor tujuan tidak valid atau tidak terdaftar di WhatsApp
            </li>
          </ul>
        </div>
        <Card>
          <div className="tab-content p-4">
            {/* ----------------All Tab------------------------------------------------------------------ */}
            <div className="tab-pane fade show active" id="allTab">
              <form onSubmit={handleSubmitSearch}>
                <div className="input-group mb-4">
                  <div className="d-flex justify-content-end">
                    <div className="input-group">
                      <input onChange={(e) => setSearch1Value(e.target.value)} type="text" className="form-control px-35px" placeholder="Search" />
                      <div className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0" style={{ zIndex: 1020 }}>
                        <i className="fa fa-search opacity-5"></i>
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-outline-default" type="submit">
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </form>

              {/* ----------------Table-------------- */}

              <div className="table-responsive">
                <table className="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th className="border-top-0 pt-0 pb-2">Recipient</th>
                      <th className="border-top-0 pt-0 pb-2">Number</th>
                      <th className="border-top-0 pt-0 pb-2">Status</th>
                      <th className="border-top-0 pt-0 pb-2">Created</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mainData.data.length > 0 ? (
                      mainData.data.map((val) => (
                        <tr key={val.id}>
                          <td className="align-middle">{val.recipient}</td>
                          <td className="align-middle">{val.phone}</td>
                          <td className="align-middle">{val.status}</td>
                          <td className="align-middle">{DateTimeFormat(val.created_at)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td>no data</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* ----------------End Table-------------- */}
            </div>

            {/* ----------------End All Tab------------------------------------------------------------------ */}
            {mainData.meta ? <Pagination3 pageInfo={mainData} nextClick={handleNextClick} prevClick={handlePrevClick} /> : ""}
          </div>
        </Card>
      </div>
    </>
  );
}

export default WhatsappOutgoing;
